import { type ErrorHandler, Injectable } from '@angular/core';

const SENSITIVE_KEYS = ['seed', 'privateKey', 'mnemonic', 'passphrase', 'secret'];

function sanitize(value: unknown): unknown {
  if (!value || typeof value !== 'object') return value;
  const obj = value as Record<string, unknown>;
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [
      k,
      SENSITIVE_KEYS.some(s => k.toLowerCase().includes(s)) ? '[REDACTED]' : v,
    ]),
  );
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (error instanceof Error) {
      console.error('[GlobalErrorHandler]', error.message, error);
    } else {
      console.error('[GlobalErrorHandler]', sanitize(error));
    }
    // TODO(#1): wire Sentry.captureException(error) once Sentry DSN is configured
  }
}
